import React from 'react';
import { motion } from 'framer-motion';
interface SocialButtonProps {
  href: string;
  label: string;
  icon: React.ReactNode;
  primary?: boolean;
}
export function SocialButton({
  href,
  label,
  icon,
  primary = false
}: SocialButtonProps) {
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 shadow-sm ${primary ? 'bg-gray-900 text-white hover:bg-gray-800' : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-168">
      {icon}
      {label}
    </motion.a>;
}